import { create } from "zustand";
import { persist } from "zustand/middleware";

export type SidebarStyle = "expanded" | "collapsed" | "topbar" | "compact";

export interface SidebarState {
  sidebarStyle: SidebarStyle;
  isCollapsed: boolean; // for expanded mode toggle
  isHoverExpanded: boolean; // for collapsed mode hover

  setSidebarStyle: (style: SidebarStyle) => void;
  setCollapsed: (collapsed: boolean) => void;
  toggleCollapsed: () => void;
  setHoverExpanded: (expanded: boolean) => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      sidebarStyle: "expanded",
      isCollapsed: false,
      isHoverExpanded: false,

      setSidebarStyle: (sidebarStyle) =>
        set({ sidebarStyle, isCollapsed: false, isHoverExpanded: false }),

      setCollapsed: (isCollapsed) => set({ isCollapsed }),

      toggleCollapsed: () =>
        set((state) => ({ isCollapsed: !state.isCollapsed })),

      setHoverExpanded: (isHoverExpanded) => set({ isHoverExpanded }),
    }),
    {
      name: "t2c-sidebar",
      partialize: (state) => ({
        sidebarStyle: state.sidebarStyle,
        isCollapsed: state.isCollapsed,
      }),
    },
  ),
);
